import { gql } from '@apollo/client';
import { AD_BASE_FIELDS } from '@/api/queries/ads.queries';
import { MAX_PAYMENT_CARDS } from '@/components/Profile/Cards/Cards.constants';

export const GET_BASE_USER = gql`
  query GetBaseUser {
    currentUser {
      id
      legacyId
      authenticationPhone
      phone
      name
      email
      emailConfirmed
      isBanned
      hasOnboardingShop
      shop {
        logo {
          url
        }
      }
      features {
        servicesFeatures {
          hasLogo
        }
      }
    }
  }
`;

export const GET_USER_BOOKMARKS = gql`
  ${AD_BASE_FIELDS}
  query GetUserBookmarks(
    $first: Int
    $after: String
    $filters: AdBookmarkFilterInput
    $orderType: AdBookmarkOrderEnum
  ) {
    currentUser {
      id
      bookmarkedCategories {
        bookmarkedAdsCount
        category {
          id
          name
        }
      }
      bookmarks(
        first: $first
        after: $after
        filters: $filters
        orderType: $orderType
      ) {
        nodes {
          category {
            id
            name
          }
          ...AdBaseFields
        }
        totalCount
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
  }
`;

export const GET_USER = gql`
  query GetUser {
    currentUser {
      id
      email
      name
      photo {
        url
      }
      authenticationPhone
      walletBalance
      cards(first: ${MAX_PAYMENT_CARDS}) {
        nodes {
          id
          legacyResourceId
          name
          pan
          paymentSystem
        }
      }
      walletDiscount
      features {
        servicesFeatures {
          hasLogo
        }
      }
      shopPaidAdsBalance
      isShop
      isActiveShop
      isBanned
    }
  }
`;
